module.exports = __webpack_public_path__ + "media/images/autopilot/speedometer-7c68695fed7b59f75e5937e75a20e8ba.svg";